<template>
  <v-container fluid>
    <material-card icon="mdi-clipboard-text" inline title="Audit Report">
      <v-btn class="add-audit-offline" v-if="auditData.status === 'COMPLETED'" outlined color="gray"
        @click="showReportPDF(auditData)">
        Download Pdf
      </v-btn>
      <a @click="$router.back()">
        <v-btn v-if="$vuetify.breakpoint.smAndUp" elevation="1" absolute right top>
          <v-icon left>mdi-arrow-left</v-icon>back
        </v-btn>
        <v-btn v-else fixed right fab small color="grey lighten-2" elevation="1" class="mr-n2 mt-10"
          style="opacity:.6;">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
      </a>
      <v-card-component>
        <br />
        <v-row>
          <v-col cols="12" md="3">
            <span class="desc">
              <v-icon color="primary">mdi-calendar</v-icon> <span class="label-color">Date:</span>
              {{ auditData.auditDate }}
            </span>
          </v-col>
          <v-col cols="12" md="3">
            <span class="desc">
              <v-icon color="primary">mdi-account</v-icon> <span class="label-color">Audited
                by:</span>
              {{this.auditData.auditedByName[0].firstName+" "+this.auditData.auditedByName[0].lastName}}
            </span>
          </v-col>
          <v-col cols="12" md="3">
            <span class="desc">
              <v-icon color="primary">mdi-billboard</v-icon> <span
                class="label-color">Center:</span>
              {{this.auditData.FranchiseeName[0].companyName}}
            </span>
          </v-col>
          <v-col cols="12" md="3">
            <span class="desc">
              <v-icon color="primary">mdi-scoreboard</v-icon> <span class="label-color">Overall
                Rating:</span>
                {{ auditData.overallScore ? Math.round(parseFloat(auditData.overallScore)) : '0' }}

            </span>
          </v-col>
        </v-row>

        <form autocomplete="off">
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-card flat class="pb-12">
                <v-card-text>
                  <v-tabs v-model="categoriesTabs" background-color="" center-active>
                    <v-tabs-slider color=""></v-tabs-slider>
                    <v-tab v-for="item in category" :key="item.id">
                      {{ item.categoryName }}
                    </v-tab>
                  </v-tabs>
                  <v-divider class="my-0 v-divider theme--light"></v-divider>
                  <v-tabs-items v-model="categoriesTabs">
                    <v-tab-item v-for="(item, catIndex) in category" :key="item.id">

                      <v-expansion-panels focusable>
                        <v-expansion-panel v-for="(subcat, subIndex) in item.subCategories"
                          :key="subcat.id">
                          <v-expansion-panel-header>{{ subcat.subCategoryName }}
                          </v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <br />

                            <h5 v-if="subcat.parameters.length === 0">No parameters available</h5>
                            <div v-for="(prm, prmIndex) in subcat.parameters" :key="prm.id">
                              <v-row>
                                <v-col cols="12" sm="3">
                                 <h3 class="v-list-item__title font-weight-regular title">{{ prm.parameterName }}</h3>
                                </v-col>
                                <v-col col="12" md="3">
                                  <!-- <label class="font-weight-medium body-2">
                                    Response Type
                                  </label>
                                  <v-autocomplete key="value" v-model="prm.responseId"
                                    label="Select Response" :items="responseLists"
                                    item-text="responseType" item-value="id" required>
                                  </v-autocomplete> -->
                                  <!-- <label class="font-weight-medium body-2">
                                    Parameter Status
                                  </label>
                                  <h4 class="my-0 py-1">{{ prm.status }}</h4> -->
                                </v-col>
                                <v-col cols="12" md="6" right>
                                  <label class="font-weight-medium body-2">
                                    Parameter Response
                                  </label>
                                  <h4 class="my-0 py-1 label-color ">{{ prm.response.responseType }}</h4>
                                  <!-- <div class="field">
                                    <v-row>
                                      <v-col cols="12" md="6">
                                        <div>
                                          <label class="font-weight-medium body-2">
                                            No. of Days
                                          </label>

                                          <v-autocomplete key="value" label="Select Days"
                                            :items="numberOptions" v-model="prm.value"
                                            item-text="nText" item-value="value"> </v-autocomplete>
                                        </div>
                                      </v-col>

                                    </v-row>
                                  </div> -->
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" md="12">
                                  <div v-if="prm.files.length > 0">
                                    <label class="font-weight-medium body-2 labels"> Files </label>
                                    <br/>
                                    <div class="d-flex list-folder-items">
                                      <div v-for="file in prm.files" :key="file.id"
                                        class="fileItems">
                                        <div class="filesList">
                                          <!-- directly calling the file path -->
                                          <a :href="file.filePath" download @click="fileOpen(file.filePath)">
                                            <v-icon>mdi-file-document-multiple-outline</v-icon>
                                            {{ file.fileName}}
                                          </a> &nbsp; &nbsp; &nbsp;
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </v-col>
                              </v-row>
                              <v-row>

                                <v-col cols="12">
                                  <label class="font-weight-medium body-2 labels">Remarks</label>
                                  <textarea  multiline class="audit-remark label-color"
                                    v-model="category[catIndex].subCategories[subIndex].parameters[prmIndex].remark "
                                    placeholder="" readonly>
                                  </textarea>
                                </v-col>
                              </v-row>
                              <hr />
                            </div>

                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </v-tab-item>
                  </v-tabs-items>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </form>
      </v-card-component>
    </material-card>
    <div v-if="isPdf">
      <audit-report :printData="printableData"></audit-report>
    </div>
  </v-container>
</template>

<script>
import MaterialCard from '@/components/template/MaterialCard'
import VCardComponent from '@/components/template/VCardComponent'
import constants from '@/utils/constants'
// import { mapGetters } from 'vuex'
import Utils from '@/utils'
import moment from 'moment'
import AuditReport from './auditReport'

export default {
  components: { VCardComponent, MaterialCard, AuditReport },
  props: ['auditId'],
  async created () {
    await this.getauditDetails()

    this.isWrite = Utils.helper.getIsWriteFun(this.$route)
  },
  computed: {},
  watch: {},
  data () {
    return {
      auditDate: moment().format('DD-MM-YYYY'),
      franchiseeID: '',
      centreList: [],
      // franchiseeOptions: [],
      isWrite: true,
      academicYearID: '',
      acadamicYearData: [],
      status: '',
      categoriesTabs: [],
      category: [],
      categoryLists: [],
      auditCategoryMaps: [],
      subCategoryLists: [],
      parameterList: [],
      responseLists: [],
      responseType: '',
      responseTypeID: '',
      selectedResponseTypeID: '',
      myDate: null,
      isPublished: '',
      dropFile: null,
      files: [],

      auditDataCopy: [],
      auditData: [],
      min: 0,
      max: 100,

      // numberOptions: [
      //   { nText: '1', value: '1' },
      //   { nText: '2', value: '2' },
      //   { nText: '3', value: '3' },
      //   { nText: '4', value: '4' },
      //   { nText: '5', value: '5' },
      //   { nText: '6', value: '6' },
      //   { nText: '7', value: '7' },
      //   { nText: '8', value: '8' },
      //   { nText: '9', value: '9' },
      //   { nText: '10', value: '10' },
      //   { nText: '11', value: '12' },
      //   { nText: '13', value: '13' },
      //   { nText: '14', value: '14' },
      //   { nText: '15', value: '15' }
      // ],

      // allowedFiles: ['m4v', 'avi', 'mpg', 'mp4', 'pdf', 'jpg', 'png', 'jpeg', 'doc', 'xlsx', 'pptx', 'ppt', 'docx', 'docm', 'xlsb', 'xlsm', 'xls', 'pps'],
      // date: new Date().toISOString().substr(0, 7),
      menu: false,

      modal: false,
      printableData: {},
      isPdf: false
    }
  },
  methods: {
    getauditDetails: async function () {
      try {
        // if (this.academicYear.id) {

        let rows = await http.get(`${constants.API_URL}/api/audit/auditbyid/${this.auditId}`)
        this.auditData = rows.data
        this.auditData.month = moment(this.auditData.auditDate).format('DD-MM-YYY')
        this.category = this.auditData.auditCategoryMaps.map(item => {
          let mainCategory = {
            auditCategoryID: item.category.id,
            categoryName: item.category.categoryName,
            // categoryScore: item.categoryScore,
            overallRemark: '',
            subCategories: []
          }

          mainCategory.subCategories = item.subCategories.map(sub => {
            console.log(sub, 'Subcat')
            let subCategory = {
              subCategoryID: sub.auditSubCategoryID,
              subCategoryName: sub.subcategoryName
            }
            subCategory.parameters = sub.parameters.map(prm => {
              console.log(prm.response.responseType, 'response test')
              return {
                parameterID: prm.id,
                parameterName: prm.parameterName,
                status: prm.status,
                parameterScore: prm.parameterScore,
                files: prm.files,
                remark: prm.remark,
                response: prm.response
              }
            })
            return subCategory
          })
          return mainCategory
        })

        this.$nextTick(() => {
          this.printInvoice('printableAssessmentArea')
        })
      } catch (e) {
        console.log(e)
        return this.$dialog.error({
          text: (e && e.response && e.response.data.message) || e.message,
          title: 'Error'
        })
      }
    },

    onChange (e) {
      console.log(e, 'tesr')
    },
    // View Methods //
    showReportPDF (auditDataList) {
      console.log(auditDataList, 'Data Listing Pdf')
      this.isPdf = true
      this.printableData = auditDataList
      this.$nextTick(() => {
        this.printInvoice('printableArea')
      })
    },
    fileOpen: async function (filePath) {
      try {
        let url = await http.get(`${constants.API_URL}/api/staff/downloadurl?s3urlKey=${filePath}`)
        window.open(url.data)
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While getting file details, ${errorMessage}`)
      }
    },
    // End of View Methods //
    checkModuleAccess: function (moduleName) {
      return Utils.helper.checkAccessByModule(this.$route, moduleName)
    },
    printInvoice: async function (content) {
      // Get HTML to print from element
      this.prtHtml = document.getElementById(content).innerHTML

      // Get all stylesheets HTML
      let stylesHtml = ''
      for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
        stylesHtml += node.outerHTML
      }

      // Open the print window
      const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=1300,toolbar=0,scrollbars=0,status=0')

      WinPrint.document.write(`<!DOCTYPE html>
<html>
  <head>
    ${stylesHtml}
  </head>
  <body>
    ${this.prtHtml}
  </body>
  <style>

  @media print {
    .page-break {
        height: 0;
        page-break-before: always;
        margin: 0;
        border-top: none;
    }
}

body, p{
    font-size: 9pt;
    font-family: Arial, Helvetica, sans-serif;
}

body {
    margin-left: 2em;
    margin-right: 2em;
    padding-left: 2em;
}

.card{
  padding-left: 2em;
}

.page {
    height: 1300px;
    padding-top: 5px;
    page-break-after: always;
    font-family: Arial, Helvetica, sans-serif;
    position: relative;
    border-bottom: 1px solid #000;
}
  </style>
</html>`)

      WinPrint.document.close()

      WinPrint.focus()

      setTimeout(function () {
        WinPrint.print()
      }, 500)
      // WinPrint.onfocus = function () {
      //   setTimeout(function () {
      //     // WinPrint.close()
      //   }, 800)
      // }

      this.resetResult()
    },

    resetResult () {
      this.printableData = {}
      this.isPdf = false
    }
  }
}
</script>

<style scoped>
.add-audit-offline {
  position: absolute;
  right: 150px;
  top: 18px;
}

.desc {
  font-size: 18px;
}
.label-color {
  color: rgba(0, 0, 0, 0.87);
  font-weight: 400;
}
.audit-remark{
  width: 100%;
  padding-top: 20px;
}
.audit-remark:focus-visible {
  outline: none;
}
.fileItems{
  margin-right: 20px;
  padding-top: 20px;
}
.label-color{
  color: rgba(0, 0, 0, 0.87);
  font-weight: 400;
}
</style>
